import { useState, useEffect } from 'react';

export const useConfig = () => {
  const [config, setConfig] = useState({});

  useEffect(() => {
    let config = {};
    const loadConfig = async () => {
      switch (window.location.hostname) {
        
        case 'arbifox.the-cicada.com':
          config = await import('../public/config/arbifox/index.json');
          setConfig(config.default);
          break;

        case 'arbitex.the-cicada.com':
        case 'localhost':
          config = await import('../public/config/arbitex/index.json');
          setConfig(config.default);
          break;
        
        case 'wolfarbi.the-cicada.com':
          config = await import('../public/config/wolfarbi/index.json');
          setConfig(config.default);
          break;

        default:
          config = await import('../public/config/wolfarbi/index.json');
          setConfig(config.default);
      }
    };

    loadConfig();
  }, []);

  return config;
};
